import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../lib/motion";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-28 sm:py-40">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-4">
            <p className="overline mb-6">— About The Studio</p>
            <div className="font-serif-display italic text-[color:var(--gold)] text-3xl sm:text-4xl leading-tight">
              Quietly refined.
              <br />Precisely delivered.
            </div>
            <div className="mt-10 w-16 h-px bg-[color:var(--gold)]" />
          </div>

          <div className="lg:col-span-8 lg:pl-12 lg:border-l lg:border-[color:var(--border-light)]">
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[color:var(--charcoal)] font-medium">
              The backend your business
              <span className="italic text-[color:var(--gold)]"> has been missing</span>.
            </h2>
            <p className="mt-10 text-lg text-[color:var(--text-secondary)] leading-relaxed max-w-2xl">
              A done-for-you business setup for coaches, consultants, and service-based founders. Your backend moves from pieced-together to fully established — structured, organised, unmistakably professional.
            </p>

            <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-10 border-t border-[color:var(--border-light)] pt-10">
              <div>
                <p className="overline mb-3">Who it's for</p>
                <p className="text-sm text-[color:var(--charcoal)] leading-relaxed">
                  Coaches, consultants, freelancers and small business owners
                  ready for structure.
                </p>
              </div>
              <div>
                <p className="overline mb-3">The Shift</p>
                <p className="text-sm text-[color:var(--charcoal)] leading-relaxed">
                  From quietly overwhelmed to calmly in control of your backend.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
